import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SupabaseService } from '../shared/services/supabase.service';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = async (route) => {
  if (!environment.production) return true;

  const supabase = inject(SupabaseService);
  const router = inject(Router);

  // Forward OAuth errors from Supabase (site URL receives ?error= on failure)
  if (route.queryParams['error']) {
    return router.createUrlTree(['/sign-in'], { queryParams: route.queryParams });
  }

  // getSession() also handles PKCE code exchange if ?code= is present in the URL
  const { data } = await supabase.supabase.auth.getSession();
  if (data.session) {
    supabase.session.set(data.session);
    return true;
  }

  // If there was a code but exchange failed, forward an error to sign-in
  if (route.queryParams['code']) {
    return router.createUrlTree(['/sign-in'], { queryParams: { error: 'auth_failed' } });
  }

  return router.createUrlTree(['/sign-in']);
};
